/* eslint-disable react-hooks/exhaustive-deps */
import { isoDateFormat } from "common/dateFormatterConfig";
import { IOptions } from "common/reactSelectModels";
import DashboardElectricityCta from "components/electricity/DashboardElectricity/DashboardElectricityCta";
import MeteringPointSelect from "components/electricity/MeteringPointSelect";
import { MeteringPoint, MeteringPointMeasurementResolution, MeteringPointMeasurements } from "models/electricity/metering-point";
import moment from "moment";
import ElectricityConsumptionChart from "pages/electricity-consumption/components/ElectricityConsumptionChart";
import React, { useContext, useEffect, useState } from "react";
import { AuthenticationContext } from "services/context/authentication.context";
import MeteringPointService from "services/electricity/metering-point.service";
import CardLimit from "./CardLimit";
import ConsumptionCard from "./ConsumptionCard";
import DashboardChargingCta from "components/charging/DashboardCharging/DashboardChargingCta";

export default function DashboardConsumption(props: any) {

    const [loading, setLoading] = useState(true);
    const [meteringPoints, setMeteringPoints] = useState<MeteringPoint[]>([]);
    const [measurementData, setMeasurementData] = useState<MeteringPointMeasurements>();
    const [selectedMeteringPoint, setSelectedMeteringPoint] = useState<IOptions | undefined>();


    const { state } = useContext(AuthenticationContext);
    const canSeeElectricity = !!state.customer!.activeElectricityAgreementsCount;

    useEffect(() => {
        fetchMeteringPoints();
    }, [state.customerId]);

    useEffect(() => {
        fetchMeteringPointMeasurements();
    }, [selectedMeteringPoint]);

    const fetchMeteringPoints = () => {
        if (!canSeeElectricity) {
            return;
        }

        MeteringPointService.getCustomerMeteringPoints(
            state.customerId!
        ).then(res => {
            const filteredMeteringPoints = res.meteringPoints.filter(mp => mp.relatedAgreement != null && mp.address != null);
            setMeteringPoints(
                filteredMeteringPoints
            );
            const mp = filteredMeteringPoints[0];
            setSelectedMeteringPoint({ value: mp.id, label: mp.address + ' (' + mp.eic + ')' })
        })
    }

    const fetchMeteringPointMeasurements = () => {
        if (!selectedMeteringPoint?.value) {
            return;
        }

        const startDate = moment().startOf('month');
        const endDate = moment();

        setLoading(true);
        MeteringPointService.getCustomerMeteringPointMeasurements(
            state.customerId!,
            selectedMeteringPoint!.value as number,
            startDate.format(isoDateFormat),
            endDate.format(isoDateFormat),
            MeteringPointMeasurementResolution.DAY
        ).then(res => setMeasurementData(res))
        .finally(() => setLoading(false));
    }


    const currentMonthConsumptionKwh = measurementData?.statistics?.currentMonthConsumptionKwh;
    const lastYearConsumptionAtTimeOfRequestKwh = measurementData?.statistics?.lastYearConsumptionAtTimeOfRequestKwh;

    const monthConsumptionDiff = (currentMonthConsumptionKwh ?? 0) - (lastYearConsumptionAtTimeOfRequestKwh ?? 0);
    let lastYearSameMonthPercentage = 0;
    if (lastYearConsumptionAtTimeOfRequestKwh) {
        lastYearSameMonthPercentage = monthConsumptionDiff / lastYearConsumptionAtTimeOfRequestKwh * 100;
    }

    return (
        <>
            <h2 className='u-fs-20 mb-3'>TARBIMINE</h2>
            <CardLimit />
            <div className="mb-4">
                <DashboardElectricityCta />
            </div>
            <div className="mb-4">
                <DashboardChargingCta />
            </div>
            { canSeeElectricity ? <><div className="bg-white pt-2">
                <MeteringPointSelect
                    meteringPoints={meteringPoints}
                    selectedMeteringPoint={selectedMeteringPoint}
                    onMeteringPointChange={setSelectedMeteringPoint}
                    withoutBorders
                />
                <div className="my-n4">
                    <ConsumptionCard
                        title="Jooksva kuu tarbimine"
                        type='wide'
                        highlightedText={(measurementData?.statistics?.currentMonthConsumptionKwh ?? '-') + ' kWh'}
                        highlightStyle="secondary"
                        showDetails={!!lastYearConsumptionAtTimeOfRequestKwh}
                        detailsLabel="Eelmisel aastal samal ajal"
                        detailsComponent={<div className="d-flex">
                            <strong>{lastYearConsumptionAtTimeOfRequestKwh} kWh</strong>
                            <span className="text-gray-600 mx-1">|</span>
                            <strong>{lastYearSameMonthPercentage.toFixed(1)} % <i className={`icon__tailed-arrow-${lastYearSameMonthPercentage > 0 ? 'up' : 'down'} bg-dark`}></i></strong>
                        </div>}
                    /> 
                </div>
            </div>
            <div className="mb-4 mb-lg-0">
                <ElectricityConsumptionChart 
                    measurementData={measurementData}
                    loading={loading}
                    onDataPointClick={() => null}
                />
            </div></> : null}
        </>
    )
}